import { z } from 'zod'

export const labTypeSchema = z.enum([
  'bloods',
  'urine',
  'stool',
  'in_house_urinalysis',
  'cyto',
  'histo',
  'skin',
  'swab',
  'other',
])
export type LabType = z.infer<typeof labTypeSchema>

export const LAB_TYPE_LABELS: Record<LabType, string> = {
  bloods: 'Bloods',
  urine: 'Urine',
  stool: 'Stool',
  in_house_urinalysis: 'In house urinalysis',
  cyto: 'Cyto',
  histo: 'Histo',
  skin: 'Skin',
  swab: 'Swab',
  other: 'Other',
}

export const LAB_TYPES = labTypeSchema.options.map((value) => ({
  value,
  label: LAB_TYPE_LABELS[value],
}))
